import { ActionIcon } from "@mantine/core";
import IconHelp from "@src/assets/icons/tabler/help.svg?react";
import clsx from "clsx";
import { motion } from "framer-motion";
import { NavBarMenu } from "./nav-bar-menu/nav-bar-menu";

export function FloatingHelpButton() {
	return (
		<motion.div
			initial={{ scale: 0, opacity: 0 }}
			animate={{ scale: 1, opacity: 1 }}
			transition={{ delay: 0.5, type: "spring" }}
			className="fixed bottom-4 right-4 sm:hidden z-(--illumi-z-index-navbar-menu)"
		>
			<NavBarMenu
				target={
					<ActionIcon
						size={44}
						radius="xl"
						variant="filled"
						className={clsx(
							"shadow-lg hover:shadow-xl transition-shadow",
							"bg-brand-primary hover:bg-brand-primary-hover",
							"text-text-inverse",
						)}
						aria-label="Help and Resources"
					>
						<IconHelp className="w-5 h-5" />
					</ActionIcon>
				}
			/>
		</motion.div>
	);
}
